import { getReferer } from '@/common/utils/referer'
import _ from 'lodash'
import { loginProc } from '@/common/utils/login'
import { getPromotionCodeFromUrl, loginRedirectUrl } from '@/common/utils/common'
import { PATH_NAME_ADULT_CONTENTS, PATH_NAME_LOGIN, PATH_NAME_LOGIN_APPLE } from '@/common/resources/router.const'

export default [
  {
    path: 'member/login',
    name: PATH_NAME_LOGIN,
    meta: { menuIndex: 0 },
    alias: '/member/login.html',
    components: {
      bodyContent: () => import(/* webpackChunkName: "login" */'@/pages/member/login')
    }
  },
  {
    path: 'member/login_apple',
    name: PATH_NAME_LOGIN_APPLE,
    alias: '/member/login_apple.html',
    beforeEnter: (to, from, next) => {
      const referer = getReferer()
      const token = _.get(to, 'query.id_token', '')
      loginProc({ userType: 'apple', userId: token, userPassword: '', saveId: '', autoLogin: '' }).then((data) => {
        if (_.get(data, 'needselectprofile', 'n') === 'y') {
          next('/member/profile_list.html?referer=' + encodeURIComponent(referer))
        } else {
          if (referer !== '') {
            next(referer)
          } else {
            next('/')
          }
        }
      }).catch((error) => {
        const response = _.get(error, 'response', {})
        if (_.get(response, 'status', '') === 551 && _.get(response, 'data.resultcode', '') === '302') {
          const redirectUrl = _.get(response, 'data.resultoptional', '')
          const referer = getReferer()
          location.href = loginRedirectUrl(redirectUrl, getPromotionCodeFromUrl(referer))
        } else {
          alert('로그인 오류입니다.')
          next('/')
        }
      })
    }
  },
  {
    path: 'setting/adult',
    name: PATH_NAME_ADULT_CONTENTS,
    alias: 'setting/adult.html',
    components: {
      adult_contents: () => import('@/pages/settings/AdultContents')
    }
  }
]
